import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigureSectionComponent } from './configure_section.component';
import { AuthGuard, SharedModule } from '../../../shared';
import { ConfigSectionService } from './section.service';

const configureSectiondRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'setting/dfb/config/section',
    component: ConfigureSectionComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }
]);

@NgModule({
  imports: [  
    SharedModule,
    configureSectiondRouting,
    NgbModule
  ],
  declarations: [
    ConfigureSectionComponent
  ],
  providers: [
 ConfigSectionService
  ],
})
export class ConfigureSectionModule {}




// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/configure_section/section.module.ts